<template>
	<div class="brand-recommend-container">
		<div class="brand-title">品牌机构推荐</div>
		<el-scrollbar>
			<div class="brand-carousel">
				<div class="shop_div_parent" v-for="(item,index) in brandList" :key="index">
					<el-link under>
						<el-image :src="item.imgHeader" class="banner-img" />
						<h4 class="single-line-text" style="">{{item.nameAbbr}}</h4>
						<!-- <el-tag size="mini" effect='plain' color='danger'>查看店铺</el-tag> -->
					</el-link>
				</div>
			</div>
		</el-scrollbar>
	</div>
</template>

<script>
	import {
		getShopList
	} from '@/api/category.js'





	export default {
		name: 'BrandRecommend',
		data() {
			return {
				brandList: []
			}
		},






		mounted() {
			this.getData()
		},





		methods: {

			async getData() {
				const shopResult = await getShopList(10)
				if (shopResult.code == 200) {
					this.brandList = []
					this.brandList = shopResult.data
				}
			},




			// 图片加载失败时显示对应名称的占位图
			handleImgError(e, item) {
				e.target.src = `https://via.placeholder.com/150x100?text=${item.name}`
				// 可选：打印错误日志便于排查
				console.warn(`品牌【${item.name}】LOGO加载失败，已替换为占位图`)
			}





		}
	}
</script>

<style lang="scss" scoped>
	
	
	
	/* 单行文本显示核心样式 */
	.single-line-text {
		/* 强制文本在一行内显示，不换行 */
		white-space: nowrap;
		/* 隐藏超出容器宽度的文本 */
		overflow: hidden;
		/* 为溢出的文本添加省略号（...），增强用户体验 */
		text-overflow: ellipsis;
		width: 80px;
		padding-left: 5px;
		text-align: center;
		padding-right: 5px;
		margin-top: 10px;
		margin-bottom: 10px;
	}



	.shop_div_parent {
		margin-left: 10px;
		margin-right: 10px;
		padding-bottom: 5px;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		text-align: center;
		background-color: white;
	}


	.brand-recommend-container {
		border: 1px solid #ff9900;
		overflow: hidden;
		align-items: center;
		padding-right: 5px;
		display: flex;
		border-radius: 5px;

		.brand-title {
			width: 50px;
			background-color: #ff9900;
			color: #fff;
			font-weight: bold;
			padding: 10px;
			float: left;
			height: 200px;
			display: flex;
			align-items: center;
			justify-content: center;
			writing-mode: vertical-rl;
			letter-spacing: 2px;
		}

		.brand-carousel {
			padding: 5px;
			width: 100%;
			justify-content: space-around;
			display: flex;
			flex-direction: row;
		}


		.banner-img {
			height: 110px;
			width: 110px;
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}
	}
</style>